import React from 'react';
import { Helmet } from 'react-helmet';
import CAN_STORE_URL from 'containers/can-store/consts/url';
import Box from '@mui/material/Box';

function CanStoreTab(): JSX.Element {
	return (
		<>
			<Helmet>
				<link rel="stylesheet" type="text/css" href={CAN_STORE_URL.CAN_TAB_CSS} />
				<script defer={true} src={CAN_STORE_URL.CAN_TAB_JS}></script>
			</Helmet>
			<Box component="section" id="can_tabs_v1"></Box>
		</>
	);
}

export default CanStoreTab;
